import * as tslib_1 from "tslib";
import { baggageInfoActionTypes, initialBaggageInfoState } from './ActionTypes';
var reducer = function (state, action) {
    if (state === void 0) { state = initialBaggageInfoState; }
    switch (action.type) {
        case baggageInfoActionTypes.RECEIVE_BAGGAGE_INFO_STATE:
            return tslib_1.__assign({}, state, { type: action.type, baggageInfoResponse: action.baggageInfoResponse });
        default:
            return tslib_1.__assign({}, state, { type: action.type });
    }
};
export { reducer as baggageInfoReducer };
